import React from 'react';
import { DeeplinkErrorDialog } from '~/screens/DeepLink/components';

const DeepLinkLoggedOut = () => {
  return <DeeplinkErrorDialog errorMessage="Sessão expirada" />;
};

export default DeepLinkLoggedOut;
